/**
 * UserAvatar — kleiner runder Initialen-Avatar; Vollname als HTML-title-Tooltip.
 * Farbe wird aus user.id deterministisch abgeleitet, damit jeder User wiedererkennbar bleibt.
 */

import type { PresenceUser } from '../../store/presence'

export const MAX_VISIBLE = 6

const PALETTE = [
  '#0ea5e9', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6',
  '#ec4899', '#14b8a6', '#f97316', '#6366f1', '#84cc16',
]

function hashStr(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

function colorFor(id: string): string {
  return PALETTE[hashStr(id) % PALETTE.length]
}

function initials(u: PresenceUser): string {
  const first = (u.firstName || '').trim()
  const last = (u.lastName || '').trim()
  if (first || last) return `${first[0] || ''}${last[0] || ''}`.toUpperCase() || '?'
  return (u.username || u.email || '?').slice(0, 2).toUpperCase()
}

function fullName(u: PresenceUser): string {
  const parts = [u.firstName, u.lastName].filter(Boolean) as string[]
  const name = parts.length ? parts.join(' ') : u.username
  return u.isGuest ? `${name} (Gast)` : name
}

export function UserAvatar({ user, size = 28, highlight = false }: {
  user: PresenceUser
  size?: number
  highlight?: boolean
}) {
  return (
    <div
      title={`${fullName(user)} — ${user.email}`}
      style={{
        width: size, height: size, borderRadius: '50%',
        background: colorFor(user.id),
        color: '#fff',
        fontSize: Math.round(size * 0.42),
        fontWeight: 600,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: highlight ? '0 0 0 2px #1a1a1a' : 'inset 0 0 0 1px rgba(255,255,255,0.4)',
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      {initials(user)}
    </div>
  )
}
